import { ISterilisationPack } from '@principle-theorem/principle-core/interfaces';
import { AtLeast } from '@principle-theorem/shared';

export class SterilisationPack {
  static init(
    overrides: AtLeast<ISterilisationPack, 'name'>
  ): ISterilisationPack {
    return {
      description: '',
      content: [],
      deleted: false,
      ...overrides,
    };
  }
}
